// // src/components/HomePage.jsx
// import React from 'react';
// import { Link } from 'react-router-dom';
// import logo from '../assets/logo.png'; // adjust the path to your logo

// const Home = () => {
//   return (
//     <div className="min-h-screen flex flex-col items-center bg-gray-50">
//       {/* Header: Logo and Trust Name */}
//       <header className="py-8 flex flex-col items-center">
//         <img src={logo} alt="Trust Logo" className="w-24 h-24 mb-4" />
//         <h4 className="mt-4 text-3xl font-bold text-primary">Shri jivdaya mandal bhachau - managed by shri kanaksuri ahinsa dham bhachau</h4>
//       </header>
      
//       {/* Main: Login Options */}
//       <main className="flex flex-col items-center flex-grow">
//         <h2 className="text-xl mb-6">Choose your login portal</h2>
//         <div className="flex space-x-6">
//           <Link 
//             to="/admin" 
//             className="px-6 py-3 bg-primary text-white rounded shadow hover:bg-secondary transition-colors"
//           >
//             Admin Login
//           </Link>
//           <Link 
//             to="/volunteer" 
//             className="px-6 py-3 bg-primary text-white rounded shadow hover:bg-secondary transition-colors"
//           >
//             Volunteer Login
//           </Link>
//         </div>
//       </main>
      
//       {/* Footer */}
//       <footer className="py-4">
//         <p className="text-gray-600">&copy; {new Date().getFullYear()} JivDaya Trust. All rights reserved.</p>
//       </footer>
//     </div>
//   );
// };

// export default Home;


// src/components/HomePage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col items-center bg-gray-50">
      {/* Header: Logo and Trust Name */}
      <header className="py-8 flex flex-col items-center">
        <img src={logo} alt="Trust Logo" className="w-24 h-24 mb-4" />
        <h1 className="text-4xl font-extrabold text-primary text-center">
          Shri Jivdaya Mandal Bhachau
        </h1>
        <p className="mt-2 text-lg text-primary text-center">
          managed by Shri Kanaksuri Ahinsadham Bhachau
        </p>
      </header>
      
      {/* Main: Login Options */}
      <main className="flex flex-col items-center flex-grow">
        <h2 className="text-xl mb-6">Choose your login portal</h2>
        <div className="flex space-x-6">
          <Link 
            to="/admin" 
            className="px-6 py-3 bg-primary text-white rounded shadow hover:bg-secondary transition-colors"
          >
            Admin Login
          </Link>
          <Link 
            to="/volunteer" 
            className="px-6 py-3 bg-primary text-white rounded shadow hover:bg-secondary transition-colors"
          >
            Volunteer Login
          </Link>
        </div>
      </main>
      
      {/* Footer */}
      <footer className="py-4">
        <p className="text-gray-600">&copy; {new Date().getFullYear()} JivDaya Trust. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Home;
